<template>
  <app-data-editor
    :id="id"
    title="Редактирование Подвижного состава"
    resource="rolling-stocks"
    :elements="elements"
    add-message="Подвижной состав добавлен"
    edit-message="Подвижной состав изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
          {
            title: "Тип",
            name: "type",
            control: {
              type: "reference",
              component: "RollingStockType",
              resource: "rolling-stock-types",
              required: true,
              rules: [v => !!v || "Тип обязателен к заполнению"],
            },
          },
        ],
        [
          {
            title: "Объем",
            name: "volume",
            control: {
              type: "number",
              required: true,
              rules: [v => !!v || "Объем обязателен к заполнению"],
            },
            default: "",
          },
          {
            title: "Грузоподъемность",
            name: "carryingCapacity",
            control: {
              type: "number",
              required: true,
              rules: [v => !!v || "Грузоподъемность обязательна к заполнению"],
            },
            default: "",
          },
          {
            title: "Количество",
            name: "quantity",
            control: {
              type: "number",
              required: true,
              rules: [v => !!v || "Количество обязательно к заполнению"],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
